import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function EditProfilePage() {
  const navigate = useNavigate();

  return (
    <div className="container py-4">
      <h5 className="text-muted mb-3">Edit Profile</h5>

      <div className="card p-4 shadow-sm border-0">
        <h4 className="fw-semibold mb-4">Edit Profile</h4>

        <Form>
          <Row className="gy-3">
            <Col md={6}>
              <Form.Group>
                <Form.Label>First Name *</Form.Label>
                <Form.Control type="text" defaultValue="Aarohi" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Last Name *</Form.Label>
                <Form.Control type="text" defaultValue="Patel" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Date Of Birth *</Form.Label>
                <Form.Control type="date" defaultValue="2005-04-25" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Gender *</Form.Label>
                <Form.Select defaultValue="Female">
                  <option>Female</option>
                  <option>Male</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Relationship *</Form.Label>
                <Form.Select defaultValue="Daughter">
                  <option>Daughter</option>
                  <option>Son</option>
                  <option>Mother</option>
                  <option>Father</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Marital Status *</Form.Label>
                <Form.Select defaultValue="Unmarried">
                  <option>Unmarried</option>
                  <option>Married</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Mobile Number *</Form.Label>
                <Form.Control type="text" defaultValue="9898989559" />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group>
                <Form.Label>Email *</Form.Label>
                <Form.Control
                  type="email"
                  defaultValue="aarohi.patel@gmail.com"
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Label>Add Profile Photo</Form.Label>
              <div className="d-flex align-items-center">
                <img
                  src="https://i.pravatar.cc/80"
                  alt="profile"
                  className="rounded-circle me-3"
                  width="60"
                  height="60"
                />
                <Form.Control type="file" />
              </div>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-3 mt-4">
            <Button variant="secondary" onClick={() => navigate(-1)}>
              Cancel
            </Button>

            <Button variant="warning" className="text-white px-4">
              Update
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}
